<template>
    <div>
      <div class="d-flex" id="wrapper">
        <!-- Sidebar -->
        <SideBar/>
        <!-- /#sidebar-wrapper -->
        <!-- Page Content -->
        <div id="page-content-wrapper">
          <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
            <div>
              <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
              </button>
  
              <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
              </button>
            </div>
            <div class="d-flex">
              <p class="text-muted mb-0 hover-cursor">&nbsp;Invoicing /&nbsp;</p>
              <p class="text-primary mb-0 hover-cursor">Ignored List</p>
            </div>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ admin }}
                  </a>
                  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                    <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                  </div>
                </li>
              </ul>
            </div>
          </nav>
          <div class="container-fluid">
            <div class="container">
              <div class="row">
                <div class="col-md-12 grid-margin stretch-card card-div">
                  <div class="search-table container-fluid">
                    <div class="row"> 
                        <div class="col-lg-12 col-sm mobile-div">
                            <div class="row">
                                <div class="col-lg-4 col-sm mobile-div">
                                    Invoice No.
                                    <input type="text" class="form-control" name="search_invoice_id" v-model="searchInvoiceNo" placeholder="Invoice Number">
                                </div>
                                <div class="col-lg-4 col-sm mobile-div">
                                    Company Name
                                    <multiselect v-model="searchCompany" :options="dataCompany" label="companyName" :allow-empty="true" :select-label="''" :deselect-label="''" placeholder="All" track-by="companyName" :multiple="false" :close-on-select="true"></multiselect>
                                </div>
                                <div class="col-lg-4 col-sm mobile-div" style="padding-right : 0px;">
                                    Reason
                                    <input type="text" class="form-control w-100" v-model="searchIgnoreReason" placeholder="Reason">
                                </div>
                                <div class="col-lg-4 col-sm mobile-div">
                                    Billing Cycle - Start
                                    <input type="date" class="form-control" name="search_invoice_billing_start_date" v-model="searchBillingCycleStart">
                                </div>
                                <div class="col-lg-4 col-sm mobile-div">
                                    Billing Cycle - End
                                    <input type="date" class="form-control" name="search_invoice_billing_end_date" v-model="searchBillingCycleEnd">
                                </div>
                                <div class="col-lg-4 col-sm mobile-div" style="display : flex; justify-content : space-between; align-items: center;">
                                  
                                  <div class="col-lg-6 col-sm mobile-div mr-3" style="padding-left : 0px;padding-right: 0px;">
                                    <button class="btn btn-primary mt-4" style="width: 100%;" @click="searchData"> Search </button>
                                  </div>
                                  <div class="col-lg-6 col-sm mobile-div" style="padding-left : 0px; padding-right: 0px;">
                                    <button class="btn btn-outline-primary mt-4" style="width: 100%;" @click="resetFilter"> Reset </button>
                                  </div>
                                  
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="row">
                        
                    </div>
                      
                    <!-- </div> -->
                   
                  </div>
      
                  <button class="btn btn-secondary btn-md mb-3 mt-3" :disabled="loadingActivateInvoiceProcess == true" v-if="selectedRows.length == 0"> 
                    <img src="~@/assets/icon/activate-doc.png" style="height: 22px;">
                    Activate Invoice 
                  </button>
                  <button class="btn btn-primary btn-md mb-3 mt-3" :disabled="loadingActivateInvoiceProcess == true" @click="confirmActivateInvoice" v-else> 
                    <img src="~@/assets/icon/activate-doc.png" style="height: 22px;">
                    Activate Invoice 
                    <img src="~@/assets/images/2.gif" style="height: 18px; margin-right: 1px;" v-if="loadingActivateInvoiceProcess == true"/>
                  </button>
  
                  <span 
                    class="ml-3" 
                    style="
                      color: #FF5D5D;
                      font-size: 16px;
                      font-style: normal;
                      font-weight: 400;
                      line-height: 20px;
                      letter-spacing: -0.016px;"
                  >
                      {{errorModifyInvoiceData}} 
                  </span>
          
                  <table class="table table-sm table-bordered table-striped table-responsive-sm">
                    <thead class="">
                      <tr>
                        <th style=" text-align: center;"> 
                          <input type="checkbox" @change="selectAllRows" :checked="checkIsSelectAll()">
                        </th>
                        <th style=" text-align: center;">Invoice No.</th>  
                        <th style=" text-align: center;">Company Name</th>
                        <th style=" text-align: center;">Total Amount</th>
                        <th style=" text-align: center;">Billing Cycle</th>
                        <th style=" text-align: center;">Billed Per</th>
                        <th style=" text-align: center;">Due Date</th>
                        <th style=" text-align: center;">Reason</th>
                        <th style=" text-align: center;">Ignored Status</th>
                      </tr>
                    </thead>
                      <tbody>
                        <tr v-if="loadingTable === false && totalData == 0">
                          <td colspan="9" class="text-center">Data Not Available</td>
                        </tr>
                        <tr v-else-if="loadingTable === true">
                          <td colspan="9" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                        </tr>
                        <tr v-for="(data,index) in pendingInvoiceData" :key="index" v-else-if="loadingTable === false && totalData != 0">
                          <td style=" text-align: center;">
                            <input type="checkbox" v-model="selectedRows" :value="data" v-if="!['Pending','On Progress'].includes(data.jurnalStatus)">
                          </td>
                          <td>
                            {{data.code}}
                          </td>
                          <td>
                            <router-link 
                              :to="{
                                path:'/invoicing/ignore/detail', 
                                query: {
                                  companyName : data.companyName,
                                  invoiceId : data.invoiceId,
                                  page : 1,
                                  itemPerPage : 10,
                                }
                              }"
                            >
                            {{ data.companyName }}
                            </router-link>
                            <div> 
                              <div class="badge jurnal-badge-warning" v-if="data.jurnalStatus == 'Pending' || data.jurnalStatus == 'On Progress'">
                                <img src="@/assets/icon/icon-danger.png" style="width: 14px; margin-bottom : 2px;margin-top : 1px;"/>
                                <span style="margin-top : 2px;">{{data.jurnalStatus}}</span>
                              </div>
                              <div class="badge jurnal-badge-danger" v-if="data.jurnalStatus == 'Failed'">
                                <img src="@/assets/icon/icon-failed.png" style="width: 14px; margin-bottom : 2px;margin-top : 1px;"/>
                                <span style="margin-top : 2px;">{{data.jurnalStatus}}</span>
                              </div>
                            </div>
                          </td>
                          <td width="15%" style=" text-align: center;">Rp {{formatPrice(data.totalAmount)}}</td>
                          <!-- <td>Invoice Category</td> -->
                          <td>
                            <div class="row">
                              <div class="col-12" style=" text-align: center;">
                                <div>
                                  {{formatDate(data.billingCycle, 'DD MMMM YYYY')}}
                                </div>
                                <span v-if="new Date(data.billingCycle).setHours(23, 59,59) < new Date()"
                                style="color: #FF5D5D;
                                  font-size: 16px;
                                  font-style: normal;
                                  font-weight: 400;
                                  line-height: 20px;
                                  letter-spacing: -0.016px;">
                                  (Overdue)
                                </span>
                                
                              </div>
                            </div>
                          </td>
                          <td style=" text-align: center;">{{ data.billedPer}}</td>
                          <td style=" text-align: center;">{{ formatDate(data.dueDate, 'DD MMM YYYY') }}</td>
                          <td style=" text-align: center;">{{ data.ignoredReason}}</td>
                          <td width='10%' style=" text-align: center;">{{ data.ignoredStatus}}</td>
                        </tr>
                      </tbody>
                  </table>
                  <div id="wrapperr">
                      <div id="c1" style="display: inline-flex;">
                        <div style="margin-right: 10px;">
                          <select class="form-control form-control-sm" v-model="itemPerPage" @change="showPage()">
                                  <option value="10">10</option>
                                  <option value="40">40</option>
                                  <option value="80">80</option>
                          </select>
                        </div>
                        <div class="alignLeft total-data">
                          Total Data {{ totalData }} 
                        </div>
                      </div>
                      <div id="c2">
                        <div class="pagination p8 alignRight">
                          <ul>
                            <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1"><li>{{'<'}}</li></a>
                            <a class="page"><li>{{ currentPage }} of {{ totalPage }} page</li></a>
                            <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage"><li>{{'>'}}</li></a>
                          </ul>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { required } from 'vuelidate/lib/validators'
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import SideBar from '../SideBar'
  import Swal from "sweetalert2";
  import moment from "moment";
  
  export default {
    name: 'IgnoredInvoiceListPage',
    components:{
      SideBar,
      Multiselect,
      // VueDatePicker
    },
    data () {
      return {
        admin:"",
        permission:[],
        viewDashboard: false,
        viewOrder: false,
        viewReturn: false,
        viewProduct: false,
        viewPairing: false,
        viewReconcile: false,
        viewResolution: false,
        viewLessor: false,
        viewLessee: false,
        viewEmployee: false,
        viewInvoicing : false,
        viewPendingInvoice : false,
        editOrder: false,
        editReturn: false,
        editProduct: false,
        editPairing: false,
        editReconcile: false,
        editResolution: false,
        editLessor: false,
        editLessee: false,
        editEmployee: false,
        dataComplain: [],
        orderId:"",
        companyName:"",
        statusOrder:"",
        loadingTable: true,
        loadingButtonProcess:false,
        loadingCreateInvoiceProcess:false,
        loadingActivateInvoiceProcess:false,
        codeChoose:'',
        productCode:[],
        companyChoose:'',
        lesseeCompany:[],
        problem:'',
        picName:'',
        picPhone:'',
        note:'',
        countOrderCode:0,
        caseKnowledge:[],
        caseKnowledgeShow:false,
        idBefore:[],
        isSolution:false,
        endOfCase:false,
        caseInfo:'',
        fieldCompanyError:false,
        fieldCodeError:false,
        fieldTypeSameError:false,
        fieldProblemError:false,
        fieldClientAddressError:false,
        errorMessage:'',
        monthName : ['January','February','March','April','May','June','July','August','September','October','November','December'],
        pendingInvoiceData : [],
        totalPage:0,
        totalData:0,
        currentPage:1,
        itemPerPage : 10,
        selectedRows : [], 
        isCheckAll : false,
        dataCompany : [],
        searchCompany : '',
        searchBillingCycleStart : null,
        searchBillingCycleEnd : null,
        searchOrderId : '',
        errorModifyInvoiceData : '',
        searchInvoiceNo : '',
        searchIgnoreReason : '',
        progressStatusOptions : [
          {
            status : '',
            statusName: 'All',
          },
          {
            status : 'Pending',
            statusName: 'Pending',
          },
          {
            status : 'On Progress',
            statusName: 'On Progress',
          },
          {
            status : 'Failed',
            statusName: 'Failed',
          },
        ],
        searchProgressStatus : {
          status : '',
          statusName: 'All'
        },
        newBillingCycle : '',
        selectedInvoiceId : '',
      }
    },
    validations: {
          picName: {
              required
          },
          picPhone: {
              required,
              phoneFormat(phoneNumber) {
                  return (
                      phoneNumber.toString().substring(0, 3) == '628' ||
                      phoneNumber.toString().substring(0, 2) == '08' ||
                      phoneNumber.toString().substring(0, 2) == '02'
                  )
              },
          },
          validationNext: ['picName', 'picPhone'],
      },
    methods: {
      formatDate(value, dateFormat) {
        return moment(value).format(dateFormat)
      },
      confirmActivateInvoice() {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-primary ml-2",
                cancelButton: "btn btn-secondary",
                actions : 'right-action-button'
            },
            buttonsStyling: false
        });

        swalWithBootstrapButtons
        .fire({
          title:
            "<strong style='font-size : 24px; font-weight : 500;'>Apakah anda yakin ingin mengaktifkan invoice ini ?</strong>",
          icon: "warning",
          width: "32rem",
          reverseButtons: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: `
            Save
          `,
          cancelButtonText: `
            Cancel
          `,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.activateInvoice();
          }
        });
      },
        activateInvoice() {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                    confirmButton: "btn btn-primary ml-2",
                    cancelButton: "btn btn-secondary",
                },
                buttonsStyling: false
            });

            const arrId = this.selectedRows.map(item => item.invoiceId)

            this.$http.post(`${process.env.IGNORE_OR_ACTIVATE_INVOICE}`,
            {
                ids: arrId,
                Ignored: false,
                IgnoredReason:  this.inputIgnoreReason ? this.inputIgnoreReason.trim() : ''
            },
            {
            headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
            if(response.data.status != 200) {
                swalWithBootstrapButtons.fire({
                    title:"Oops...",
                    html: `
                        <div style="max-width : 100%">
                            <span style="color : #F06400;font-size: 16px;">Invoice gagal diaktifkan</span>
                        </div>
                    `,
                    icon: "error",
                    width: "32rem",
                    reverseButtons: true,
                    focusConfirm: false,
                    confirmButtonText: `
                        Back
                    `,
                }).then((result) => {
                    if(result.isConfirmed) {
                        window.location.reload()
                    }
                });
            } else {
                swalWithBootstrapButtons.fire({
                    title:"Success",
                    html: `
                        <div style="max-width : 100%">
                            <span style="color : #565656;font-size: 18px;font-weight: 600;text-align: center;">Invoice Sudah Aktif</span>
                            <br/>
                            <br/>
                            <div style="
                                font-size: 16px;
                                font-weight: 400;
                                line-height: 19.36px;
                                text-align: center;
                                text-underline-position: from-font;
                                text-decoration-skip-ink: none;
                            ">
                                Silahkan masuk ke menu Pending Invoice
                            </div>
                        </div>
                    `,
                    icon: "success",
                    width: "32rem",
                    reverseButtons: true,
                    focusConfirm: false,
                    confirmButtonText: `
                        OK
                    `,
                }).then((result) => {
                    if(result.isConfirmed) {
                        localStorage.setItem("selectedIgnoreInvoice", JSON.stringify([]))
                        window.location.reload()
                    }
                });
            }
            })
            .catch(error => {
                swalWithBootstrapButtons.fire({
                    title:"Oops...",
                    html: `
                        <div style="max-width : 100%">
                            <span style="color : #F06400;font-size: 16px;">${error.response.data.message ? error.response.data.message : error.message}</span>
                        </div>
                    `,
                    icon: "error",
                    width: "32rem",
                    reverseButtons: true,
                    focusConfirm: false,
                    confirmButtonText: `
                        Back
                    `,
                }).then((result) => {
                    if(error.response.data.status == 401) {
                      this.handleLogout()
                    } else {
                      window.location.reload()
                    }
                });
            })
        },
     
      formatPrice(value) {
          let val = value  ? Number(value) : Number(0)
          const round = val.toString().split('.')[0]
          const decimal = val.toString().split('.')[1]
  
          let result = round.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          result = decimal ? `${result},${decimal}` : `${result},00`
        
          return result
      },
      showPage () {
        this.$router.push({path:'/invoicing/ignore', query: {
            page : 1,
            itemPerPage : this.itemPerPage,
            companyId: this.searchCompany ? this.searchCompany.companyId : '',
            companyName: this.searchCompany ? this.searchCompany.companyName : '',
            billingCycleStart : this.searchBillingCycleStart ?  this.searchBillingCycleStart  : '',
            billingCycleEnd : this.searchBillingCycleEnd ?  this.searchBillingCycleEnd  : '',
            invoiceNumber: this.searchInvoiceNo ? this.searchInvoiceNo : '',
            jurnalStatus : this.searchProgressStatus ? this.searchProgressStatus.status : '',
            jurnalStatusName : this.searchProgressStatus ? this.searchProgressStatus.statusName : '',
            orderId : this.searchOrderId ? this.searchOrderId : '',
            ignoreReason : this.searchIgnoreReason ? this.searchIgnoreReason : '',
          }
        })
      },
      checkIsSelectAll() {
        let checked = 0
        this.pendingInvoiceData.forEach(data => {
          if(this.selectedRows.find(item => item.invoiceId == data.invoiceId)) {
            checked += 1
          }
        })
  
        if( this.pendingInvoiceData.length > 0&& checked == this.pendingInvoiceData.length) {
          return true
        } else {
          return false
        }
      },
      selectAllRows() {
        const isSelectAll = this.checkIsSelectAll()
        console.log(isSelectAll)
        let datas = this.pendingInvoiceData
        if (!isSelectAll) {
          datas.forEach(item => {
            if(!this.selectedRows.find(data => data.invoiceId == item.invoiceId)) {
              this.selectedRows.push(item)
            }
          })
          localStorage.setItem("selectedIgnoreInvoice", JSON.stringify(this.selectedRows))
        } else {
         datas.forEach(item => {
            const index = this.selectedRows.findIndex(data => item.invoiceId == data.invoiceId); 
            if(this.selectedRows.find(data => item.invoiceId == data.invoiceId)) {
              this.selectedRows.splice(index, 1);
            }
          })
          localStorage.setItem("selectedIgnoreInvoice", JSON.stringify(this.selectedRows))
        }
      },
      getCompanyData() {
        this.$http.get(process.env.GET_COMPANY, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });
            this.handleLogout();
          } else {
            this.dataCompany = [{companyId : null, companyName : 'All'}, ...response.data.content];
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });          
      },
      closeModal(name){
        $("#modal"+name).modal('hide')
      },
      isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
              evt.preventDefault();
            } else {
              return true;
            }
      },
      cekField: function(buttonName){
        var error = 0
        this.fieldCompanyError = false
        this.fieldCodeError = false
        this.fieldTypeSameError = false
        this.fieldPicNameError = false
        this.fieldPicPhoneError = false
        this.$v.validationNext.$touch()
  
        if (buttonName == 'etc' && this.problem == '') {
            error = error+1
            this.fieldProblemError = true
        } else if(buttonName == 'etc' && this.clientAddress == '') {
          error = error+1
          this.fieldClientAddressError= true
        } else{
            if (this.companyChoose == '') {
              error = error+1
              this.fieldCompanyError = true
            }
            if (this.codeChoose == '') {
              error = error+1
              this.fieldCodeError = true
            }
            if (this.countOrderCode == '2' && this.typeChoose == '') {
              error = error+1
              this.fieldTypeSameError = true
            }
            if (this.$v.validationNext.$invalid) {
               error = error+1           
            }
        }
        return error
      },
  
      openModal(x) {
        $("#modal"+x).modal('show')
      },
      resetFilter() {
        this.searchInvoiceNo = ''
        this.searchCompany = ''
        this.searchBillingCycleStart = ''
        this.searchBillingCycleEnd = ''
        this.searchIgnoreReason = ''
        this.searchData()
      },
      searchData(){     
        this.$router.push({path:'/invoicing/ignore', query: {
            page : 1,
            itemPerPage : 10,
            companyId: this.searchCompany ? this.searchCompany.companyId : '',
            companyName: this.searchCompany ? 
              (!this.searchCompany.companyName || this.searchCompany.companyName == 'ALL' ? '' : this.searchCompany.companyName) : '',
            billingCycleStart : this.searchBillingCycleStart ?  this.searchBillingCycleStart  : '',
            billingCycleEnd : this.searchBillingCycleEnd ?  this.searchBillingCycleEnd  : '',
            invoiceNumber: this.searchInvoiceNo ? this.searchInvoiceNo : '',
            jurnalStatus : this.searchProgressStatus.status ? this.searchProgressStatus.status : '',
            jurnalStatusName : this.searchProgressStatus ? 
              (!this.searchProgressStatus.statusName || this.searchProgressStatus.statusName == 'ALL' ? '' : this.searchProgressStatus.statusName) : '',
            orderId : this.searchOrderId ? this.searchOrderId : '',
            ignoreReason : this.searchIgnoreReason ? this.searchIgnoreReason : '',
          }
        })
        // this.getData()
      },
      toDataPage(pagePost){
        this.loadingTable = true
        this.$router.push({path:'/invoicing/ignore', query: {
            page : pagePost,
            itemPerPage : this.itemPerPage,
            companyId: this.searchCompany ? this.searchCompany.companyId : '',
            companyName: this.searchCompany ? this.searchCompany.companyName : '',
            billingCycleStart : this.searchBillingCycleStart ?  this.searchBillingCycleStart  : '',
            billingCycleEnd : this.searchBillingCycleEnd ?  this.searchBillingCycleEnd  : '',
            invoiceNumber: this.searchInvoiceNo ? this.searchInvoiceNo : '',
            jurnalStatus : this.searchProgressStatus ? this.searchProgressStatus.status : '',
            jurnalStatusName : this.searchProgressStatus ? this.searchProgressStatus.statusName : '',
            orderId : this.searchOrderId ? this.searchOrderId : '',
            ignoreReason : this.searchIgnoreReason ? this.searchIgnoreReason : '',
          }
        })
       
        this.getData()
      },
      toPage(e) {
        this.$router.push(e)
      },
      async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
        localStorage.removeItem('jwt')
        localStorage.removeItem('admin_name')
        localStorage.removeItem('roles')
        localStorage.removeItem('user_email')
        localStorage.removeItem('admin_id')
        localStorage.removeItem('changeCatalogPermission')
        this.$router.push('/')
      },
      cekLogin(){
        if (localStorage.getItem('jwt') == null) {
          this.$router.push('/')
        }
      },
      cekPermission(){
        this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
        for(var i=0; i < this.permission.length; i++){
          if( this.permission[i] == "1"){
            this.viewDashboard = true
          }
          if( this.permission[i] == "2.1"){
            this.viewOrder = true
          }
          if( this.permission[i] == "2.2"){
            this.editOrder = true
          }
          if( this.permission[i] == '3.1'){
            this.viewReturn = true
          }
          if( this.permission[i] == '3.2'){
            this.editReturn = true
          }
          if( this.permission[i] == '4.1'){
            this.viewProduct = true
          }
          if( this.permission[i] == '4.2'){
            this.editProduct = true
          }
          if( this.permission[i] == '5.1'){
            this.viewPairing = true
          }
          if( this.permission[i] == '5.2'){
            this.editPairing = true
          }
          if( this.permission[i] == '6'){
            this.viewReconcile = true
          }
          if( this.permission[i] == '7.1'){
            this.viewResolution = true
          }
          if( this.permission[i] == '7.2'){
            this.editResolution = true
          }
          if( this.permission[i] == '8.1'){
            this.viewLessor = true
          }
          if( this.permission[i] == '8.2'){
            this.editLessor = true
          }
          if( this.permission[i] == '9.1'){
            this.viewLessee = true
          }
          if( this.permission[i] == '9.2'){
            this.editLessee = true
          }
          if( this.permission[i] == '10'){
            this.viewEmployee = true
          }
  
          if(this.permission[i] == '21') {
            this.viewInvoicing = true
          }
            if(this.permission[i] == '21.5') {
            this.viewInvoiceIgnored = true
          }
        }
        if (this.viewInvoiceIgnored == false) {
          this.$router.push('/')
        }
      },
      sidebar(){
        $("#wrapper").toggleClass("toggled");
      },
      getData(){
        if( this.$route.query.companyId && this.$route.query.companyName) {
          this.searchCompany = {
            companyId : this.$route.query.companyId,
            companyName: this.$route.query.companyName
          }
        }
  
        if( this.$route.query.jurnalStatus && this.$route.query.jurnalStatusName) {
          this.searchProgressStatus = {
            status : this.$route.query.jurnalStatus,
            statusName: this.$route.query.jurnalStatusName
          }
        }
  
        this.searchBillingCycleStart = this.$route.query.billingCycleStart
        this.searchBillingCycleEnd = this.$route.query.billingCycleEnd
        this.searchInvoiceNo = this.$route.query.invoiceNumber
        this.searchOrderId = this.$route.query.orderId
        this.searchIgnoreReason = this.$route.query.ignoreReason
  
        this.currentPage = parseInt(this.$route.query.page)
        this.itemPerPage = parseInt(this.$route.query.itemPerPage)
  
        this.loadingTable = true
        this.$http.post(`${process.env.GET_INVOICE_LIST}?ignored_invoice=true&pending_invoice=false`,{
          page: Number(this.$route.query.page),
          itemPerPage : Number(this.$route.query.itemPerPage),
          companyId: this.searchCompany.companyId ? Number(this.searchCompany.companyId) : null,
          companyName : this.searchCompany.companyName ? this.searchCompany.companyName : null ,
          billingCycleStart : this.$route.query.billingCycleStart ?  this.$route.query.billingCycleStart  : '',
          billingCycleEnd : this.$route.query.billingCycleEnd ?  this.$route.query.billingCycleEnd  : '',
          invoiceCode : this.$route.query.invoiceNumber ? this.$route.query.invoiceNumber  : '',
          jurnalStatus : this.$route.query.jurnalStatus ? this.$route.query.jurnalStatus : '',
          invoiceStatus: '',
          orderId : this.$route.query.orderId ? this.$route.query.orderId : '',
          ignoreReason : this.$route.query.ignoreReason ? this.$route.query.ignoreReason : ''
        },{
          timeout: 20 * 6000,
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if(response.data.status !== 200) {
            this.pendingInvoiceData = []
            swal("Error", response.data.message , "error")
            this.loadingTable = false
          } else {
  
            this.pendingInvoiceData = response.data.data.data ? [...response.data.data.data] : [...this.pendingInvoiceData] 
            this.totalPage = response.data.data.totalPage
            this.totalData = response.data.data.totalData
            this.currentPage = response.data.data.currentPage
            this.loadingTable = false
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      },
      sendLog(x){
          var today = new Date();
          var month = today.getMonth()+1
          if (month < 10) {
              month = '0'+month
          }
          var dateDay = today.getDate()
          if (dateDay < 10) {
              dateDay = '0'+dateDay
          }
          var hours = today.getHours()
          if (hours < 10) {
              hours = '0'+hours
          }
          var minutes = today.getMinutes()
          if (minutes < 10) {
              minutes = '0'+minutes
          }
          var second = today.getSeconds()
          if (second < 10) {
              second = '0'+second
          }
          var date = today.getFullYear()+'-'+month+'-'+dateDay;
          var time = hours + ":" + minutes + ":" + second;
          var dateTime = date+' '+time;
          var admin = this.admin
          var command = 'add-logs'
          var productName = this.productNameChoose
          this.$http.post(process.env.LOG_URL+"/ticket/"+x,{
              codeLogs: 36,
              params: [],
          },{
              headers: {'Asani-Token':localStorage.getItem('jwt')}
          })
          .then(response => {
          })
          .catch(error => {
              console.log(error)
          })
      }
    },  
    created(){
      this.getData()
      this.getCompanyData()
      this.selectedRows = localStorage.getItem("selectedIgnoreInvoice") ? JSON.parse(localStorage.getItem("selectedIgnoreInvoice")) : [];
      this.admin = localStorage.getItem('admin_name')
      this.cekLogin()
      this.cekPermission()
    },
    watch: {
      selectedRows: function (a) {
        localStorage.setItem("selectedIgnoreInvoice", JSON.stringify(a));
      },
    }
  }
  $(document).ready(function(){
    var self = this
  $('#modalCreate').on('hidden.bs.modal', function () {
      // self.wadaw()
  });
  });
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .right-action-button {
    width: 100%;;
  }
  .btn-confirm-primary {
    color: black;
    background-color: #3098F7;
    border-color: #BFE4FE;
  }

  .btn-cancel-secondary {
    color: #ffffff;
    background-color: #3098F7;
    border-color: #BFE4FE;
  }
    .jurnal-badge-warning{
      border-radius: 50rem;
      background: #FFDEA5;
      color: #F06400;
      padding-left: 8px;
      padding-right: 8px;
    }
    .jurnal-badge-danger{
      border-radius: 50rem;
      background: #FFC5CA;
      color: #EE2737;
      padding-left: 8px;
      padding-right: 8px;
    }
  
    .title-square-background {
      background-color: #F8F9FB;
    }
  
    .invoice-overview-indicator{
      color: #000;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px; /* 157.143% */
      letter-spacing: -0.014px;
    }
  
    .invoice-overview-value {
      color: #000;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 22px; /* 110% */
      letter-spacing: -0.02px;
    }
  
    .most-overdue-title {
      color: #000;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px; /* 157.143% */
      letter-spacing: -0.014px;
    }
  
    .most-overdue-text {
      color: #2E3646;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px; /* 157.143% */
      letter-spacing: -0.014px;
    }
  
    .most-overdue-orange {
      color: #FF5252;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px; /* 157.143% */
      letter-spacing: -0.014px;
    }
  
    .case-knowledge:hover{
      cursor: pointer;
      background-color: #2797FB;
      color: white;
    }
  .key{
    width: 168px;
    margin: 7px 0px;
  }
  .titik2{
    margin: 7px 0px;
    padding: 0px 9px;
  }
  .field{
    width: 100%;
  }
  .one-line{
    display: flex;
    margin: 4px 0px;
  }
  .pagination{
  padding: 0px 0;
  }
  
  .pagination ul{
  margin: 0;
  padding: 0;
  list-style-type: none;
  }
  
  .pagination a{
  display: inline-block;
  padding: 1px 6px;
  color: #222;
  }
  
  .p8 a{
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
  }
  
  .p8 a:hover{
  text-decoration: none;
  }
  .p8 a.page:hover{
  text-decoration: none;
  color: #fff;
  }
  
  .p8 .is-active{
  background-color: #fff;
  color: #2797FB;
  }
  
  .alignleft {
  float: left;
  }
  .alignright {
  float: right;
  }
  
  .pagg{
  display: inline-flex;
  overflow:auto;
  }
  
  .total-data{
  padding: 11px 0px;
  font-size: 14px;
  color: #343A40;
  }
  #wrapperr{
    overflow:auto;
    margin: 5px 3px;
  }
  
  #c1{
   float:left;
  }
  
  #c2{
  float: right;  
  }
  
  .search-table{
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
  }
  .active{
  color: #2797FB;
  }
  .right-dropdown{
  margin-left: 7px;
  }
  .account-div{
  margin: 2px 2px;
  }
  .right-arrow{
  margin-left: auto;
  }
  .brand-logo{
  width: 120px;
  }
  .menu-title{
  margin-left: 1.125rem;
  }
  .menu-title-order{
  margin-left: 1.95rem;
  }
  .menu-title-payment{
  margin-left: 1.525rem;
  }
  
  ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
  }
  
  li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
  }
  
  li a.active {
  background-color: #4CAF50;
  color: white;
  }
  
  li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
  }
  .nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
  }
  .nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
  }
  .nav-side-menu .toggle-btn {
  display: none;
  }
  .nav-side-menu ul,
  .nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
  }
   .nav-side-menu ul :not(collapsed) .arrow:before,
   .nav-side-menu li :not(collapsed) .arrow:before {
    font-family: FontAwesome;
    content: "\f078";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu ul .active,
  .nav-side-menu li .active {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
  }
  .nav-side-menu ul .sub-menu li.active,
  .nav-side-menu li .sub-menu li.active {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li.active a,
  .nav-side-menu li .sub-menu li.active a {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li,
  .nav-side-menu li .sub-menu li {
    background-color: #181c20;
    border: none;
    line-height: 28px;
    border-bottom: 1px solid #23282e;
    margin-left: 0px;
  }
  .nav-side-menu ul .sub-menu li:hover,
  .nav-side-menu li .sub-menu li:hover {
    background-color: #020203;
  }
  .nav-side-menu ul .sub-menu li:before,
  .nav-side-menu li .sub-menu li:before {
    font-family: FontAwesome;
    content: "\f105";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu li {
    padding-left: 0px;
    border-left: 3px solid #2e353d;
    border-bottom: 1px solid #23282e;
  }
  .nav-side-menu li a {
    text-decoration: none;
    color: #e1ffff;
  }
  .nav-side-menu li a i {
    padding-left: 10px;
    width: 20px;
    padding-right: 20px;
  }
  .nav-side-menu li:hover {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
    -webkit-transition: all 1s ease;
    -moz-transition: all 1s ease;
    -o-transition: all 1s ease;
    -ms-transition: all 1s ease;
    transition: all 1s ease;
  }
  @media (max-width: 767px) {
    .nav-side-menu {
      position: relative;
      width: 100%;
      margin-bottom: 10px;
    }
    .nav-side-menu .toggle-btn {
      display: block;
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 10 !important;
      padding: 3px;
      background-color: #ffffff;
      color: #000;
      width: 40px;
      text-align: center;
    }
    .brand {
      text-align: left !important;
      font-size: 22px;
      padding-left: 20px;
      line-height: 50px !important;
    }
  }
  @media (min-width: 767px) {
    .nav-side-menu .menu-list .menu-content {
      display: block;
    }
  }
  @media (max-width: 573px){
    .mobile-div{
      padding: 2px 0px;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Invoicing/InvoiceIgnorePage.vue